import { useState, useEffect } from "react";
import { head } from 'ramda';

import { getGuestbooks } from "../requests";

function useGuestbook(articleId) {
  const [guestbookKey, setGuestbookKey] = useState(null);
  const [totalComments, setTotalComments] = useState(0);

  const increaseTotalComments = () => setTotalComments(totalComments + 1);

  useEffect(() => {
    setGuestbookKey(null);
    setTotalComments(0);

    getGuestbooks([articleId])
      .then(head)
      .then(({ guestbookKey, totalComments }) => {
        setGuestbookKey(guestbookKey);
        setTotalComments(totalComments);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [articleId]);

  return [totalComments, guestbookKey, increaseTotalComments];
}

export { useGuestbook };
